import { render, staticRenderFns } from "./manage-platforms.vue?vue&type=template&id=07801bda&scoped=true&"
import script from "./manage-platforms.vue?vue&type=script&lang=js&"
export * from "./manage-platforms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07801bda",
  null
  
)

export default component.exports